export const navigationRoutes = [
  { activeNavLink: "Dashboard", path: "/dashboard" },
  { activeNavLink: "Occupancy", path: "/occupancy" },
  { activeNavLink: "Carfinder", path: "/carfinder" },
  {
    activeNavLink: "PassageControlService",
    path: "/passageControlService",
  },
  {
    activeNavLink: "StateControllerService",
    path: "/stateControllerService",
  },
  { activeNavLink: "AXAKoelnParkpreise", path: "/axakoeln" },
  { activeNavLink: "Statistics", path: "/statistics" },
  { activeNavLink: "ReservationService", path: "/reservationservice" },
  { activeNavLink: "EventLogs", path: "/events" },
  { activeNavLink: "Settings", path: "/settings" },
];

export const normalizeActiveNavLinks = (activeNavLinks) =>
  Array.isArray(activeNavLinks) ? activeNavLinks : [];

export const getStoredActiveNavLinks = () => {
  try {
    return normalizeActiveNavLinks(
      JSON.parse(localStorage.getItem("activeNaviLinks")),
    );
  } catch (error) {
    return [];
  }
};

export const canAccessNavLink = (activeNavLinks, activeNavLink) =>
  activeNavLink === "active" ||
  normalizeActiveNavLinks(activeNavLinks).includes(activeNavLink);

export const getFirstAccessibleRoute = (activeNavLinks) => {
  const accessibleLinks = normalizeActiveNavLinks(activeNavLinks);
  const route = navigationRoutes.find(({ activeNavLink }) =>
    accessibleLinks.includes(activeNavLink),
  );

  return route ? route.path : null;
};
